module.exports = __webpack_public_path__ + "static/hero-slide3-71c862f2150c10459530082b366c95ce.mp4";